module.exports = __webpack_public_path__ + "img/Eventos_Environment.d09974a4.png";